import { Type } from '@rtls/core/models/shared/type.model';
import { randomName, randomWord } from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts';

export const typeFactory = Factory.makeFactory<Type>({
	key: Factory.each(() => randomName()),
	templates: Factory.each(() => {
		return {
			fr: 'fr',
			en: 'en',
		};
	}),
	translation: Factory.each(() => randomWord()),
});
